import { MDBIcon } from "mdb-react-ui-kit";

const PurchaseResultsDialog = ({
  successNumbers = [],
  failedNumbers = [],
}) => {
  return (
    <>
      {/* Success Section */}
      {successNumbers.length > 0 && (
        <div className="mb-4">
          <div className="d-flex align-items-center mb-2 fs-1">
            {/* <CheckCircle size={20} className="text-success me-2" /> */}
            <MDBIcon far icon="check-circle" size={25} className="text-success me-2"  />
            <h6 className="mb-0 fw-bold">
            Successfully purchased phone numbers:({successNumbers.length})
            </h6>
          </div>

          <div
            style={{
              backgroundColor: "#e6f4ea",
              border: "1px solid #c7e6d3",
              borderRadius: "10px",
              padding: "12px",
              maxHeight: "180px",
              overflowY: "auto",
            }}
          >
            <div className="row">
              {successNumbers.map((number, idx) => (
                <div key={idx} className="col-md-6 mb-1">
                  <span
                    className="me-2"
                    style={{ color: "#1e8e3e", fontSize: "18px" }}
                  >
                    ●
                  </span>
                  <span className="font-monospace text-dark">
                    {number}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Failed Section */}
      {failedNumbers.length > 0 && (
        <div>
          <div className="d-flex align-items-center mb-2">
            {/* <AlertTriangle size={20} className="text-warning me-2" /> */}
            <MDBIcon fas icon="exclamation-triangle" size={20} className="text-warning me-2"/>
            <h6 className="mb-0 fw-bold">
              The following phone numbers could not be purchased due to unavailability: ({failedNumbers.length})
            </h6>
          </div>

          <div
            style={{
              backgroundColor: "#fff4e5",
              border: "1px solid #f3d19c",
              borderRadius: "10px",
              padding: "12px",
              maxHeight: "180px",
              overflowY: "auto",
            }}
          >
          
            <div className="row">
              {failedNumbers.map((number, idx) => (
                <div key={idx} className="col-md-6 mb-1">
                  <span
                    className="me-2"
                    style={{ color: "#d97706", fontSize: "18px" }}
                  >
                    ●
                  </span>
                  <span className="font-monospace text-dark">
                    {number}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PurchaseResultsDialog;
